import { POST_KEY } from '../../index'
import addRequestNetworkUtil from '../../../../../modules/network/utils/add-request'
import POSTS_ACTION from '../../../../../modules/posts/constants/action'
import POSTS_ENDPOINT from '../../../../../modules/posts/constants/endpoint'
import POST_TYPE_TO_DOMAIN_LIST_PATH from '../../../../../modules/posts/constants/type-to-domain-list-path'
import { getIdReduxUtil } from '../../../../../modules/redux/utils/get-id'
import { getPathReduxUtil } from '../../../../../modules/redux/utils/get-path'
import { getValueReduxUtil } from '../../../../../modules/redux/utils/get-value'
import isTemporaryIdReduxUtil from '../../../../../modules/redux/utils/is-temporary-id'
import updateReduxUtil from '../../../../../modules/redux/utils/update'
import setUtil from '../../../../../utils/set'

function afterSaveAssociationPostHook (instance, state, options) {
  const {
    association
  } = options

  const attachmentId = getValueReduxUtil(instance, POST_KEY.ATTACHMENT_ID)
  if (!isTemporaryIdReduxUtil(attachmentId)) {
    return state
  }

  const newInstance = updateReduxUtil(instance, {
    [POST_KEY.ATTACHMENT_ID]: getIdReduxUtil(association)
  })
  const type = getValueReduxUtil(instance, POST_KEY.TYPE)
  const domainListPath = POST_TYPE_TO_DOMAIN_LIST_PATH[type]

  // If the instance was changed after the hook,
  // put in in the queue to save
  state = addRequestNetworkUtil({
    state,
    action: {
      type: POSTS_ACTION.SAVE_AFTER_ASSOCIATION_SAVED,
      payload: {
        endpoint: POSTS_ENDPOINT.POSTS,
        path: getPathReduxUtil(newInstance),
        domainListPath
      }
    }
  })

  return setUtil(state, getPathReduxUtil(newInstance), newInstance)
}

export default afterSaveAssociationPostHook
